import { Box, Typography } from "@mui/material";
import React from "react";
import Brightness1RoundedIcon from "@mui/icons-material/Brightness1Rounded";

const StatusCard = ({ userProfileData, isRcs }) => {

  return (
    <>
      {isRcs ? (
        <Box
          sx={{
            display: "flex",
            justifyItems: "space-between",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Typography sx={{ color: "#008026" }}>
            <Brightness1RoundedIcon sx={{ height: "10px", width: "auto" }} />
          </Typography>

          <Typography
            sx={{
              color: "#008026",
              textTransform: "capitalize",
              fontSize: "14px",
            }}
          >
            connected
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyItems: "space-between",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Typography
            sx={{
              color: userProfileData?.whatsappBusinessApiStatus
                ? "#008026"
                : "#5A5A5A",
            }}
          >
            <Brightness1RoundedIcon sx={{ height: "10px", width: "auto" }} />
          </Typography>

          <Typography
            sx={{
              color: userProfileData?.whatsappBusinessApiStatus
                ? "#008026"
                : "#5A5A5A",
              textTransform: "capitalize",
              fontSize: "14px",
            }}
          >
            {userProfileData?.whatsappBusinessApiStatus?.toLowerCase()}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default StatusCard;
